module.exports = __webpack_public_path__ + "static/media/img1.c5c0622c.jpg";